export default __webpack_public_path__ + "884ddd81f4b509c7521ad56e5d0da0e4.png";